import React from 'react'
import { TextField } from '@mui/material';

export default function Input(props) {

    const { name, label, value,error=null, placeholder, onChange, disabled, readOnly, ...other} = props;
    return (
        <TextField
            variant="outlined"
            margin="dense"
            label={label}
            name={name}
            value={value}
            onChange={onChange}
            disabled={disabled}
            readOnly={readOnly}
            placeholder={placeholder}
            fullWidth
            {...other}
            {...(error && {error:true,helperText:error})}
        />
    )
}